<ng-container>
  <p-multiSelect
    #multiselect
    [id]="id || name"
    [disabled]="disabled"
    [options]="optionsForMultiselect"
    (onPanelShow)="getOptions($event)"
    defaultLabel="Selecione"
    [maxSelectedLabels]="maxSelectedLabels"
    [showToggleAll]="showToggleAll"
    [virtualScroll]="virtualScroll"
    selectedItemsLabel="{0} {{selectedItemsLabel}}"
    (onSelect)="onChange.emit($event)"
    [ngClass]="customClass"
    (focusout)="onFocusOut.emit($event)"
    (onKeyUp)="onKeyUp($event)"
    characterPattern="[А-Яа-я]"
    [style]="{ display: 'grid' }"
    [(ngModel)]="value"
    (ngModelChange)="setFormControl($event)"
    emptyFilterMessage="Nenhum resultado foi encontrado"
  >
  </p-multiSelect>
</ng-container>

